import { ANNOTATION_LABEL, annotationSegments, type AnnotationKind } from "@/lib/pilot";
import { cn } from "@/lib/utils";

const TONE: Record<AnnotationKind, string> = {
  missing: "bg-amber-100 text-amber-900 ring-amber-300",
  proof: "bg-orange-50 text-orange-900 ring-orange-200",
  case: "bg-violet-50 text-violet-900 ring-violet-200",
  decision: "bg-sky-50 text-sky-900 ring-sky-200",
  contradicted: "bg-rose-50 text-rose-900 ring-rose-200",
  conflict: "bg-rose-50 text-rose-900 ring-rose-200",
  other: "bg-slate-100 text-slate-800 ring-slate-300",
};

/**
 * A draft as written, its `[[…]]` passages marked as draft annotations: what
 * still needs a proof, a value or a decision. They are never sendable.
 */
export function AnnotatedText({ text, className }: { text: string; className?: string }) {
  return (
    <span className={cn("whitespace-pre-wrap", className)}>
      {annotationSegments(text).map((segment, index) =>
        segment.annotation ? (
          <mark
            key={index}
            title={`${ANNOTATION_LABEL[segment.annotation]} — draft annotation, never sent`}
            className={cn("rounded px-0.5 ring-1 ring-inset [box-decoration-break:clone]", TONE[segment.annotation])}
          >
            {segment.text}
          </mark>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </span>
  );
}

export function AnnotationLegend() {
  const kinds: AnnotationKind[] = ["missing", "proof", "case", "decision", "contradicted"];
  return (
    <div className="flex flex-wrap items-center gap-1.5 text-[11px] text-slate-500">
      <span>Draft annotations (never sent):</span>
      {kinds.map((kind) => (
        <span key={kind} className={cn("rounded px-1.5 py-0.5 ring-1 ring-inset", TONE[kind])}>
          {ANNOTATION_LABEL[kind]}
        </span>
      ))}
    </div>
  );
}
